import { useQuery } from "@tanstack/react-query";
import { api } from "../lib/api";
import type { TaskFinding } from "../../../shared/types";

export function useRunFindings(runId: string | undefined) {
  return useQuery({
    queryKey: ["task-run-findings", runId],
    queryFn: () =>
      api.get<{ data: TaskFinding[] }>(`/api/task-runs/${encodeURIComponent(runId!)}/findings`),
    enabled: !!runId,
    staleTime: 60_000,
  });
}
